module.exports = __webpack_public_path__ + "assets/image_print.png";


//////////////////
// WEBPACK FOOTER
// ./images/image_print.png
// module id = 315
// module chunks = 0